module.exports = __webpack_public_path__ + "img/satellite-5aab2b9.png";